import React from 'react';
import { FormSectionTitle } from '../atoms/FormSectionTitle';
import { RadioButton } from '../atoms/RadioButton';

type RadioButtonProps = React.InputHTMLAttributes<HTMLInputElement> & {
  label: string;
} & React.RefAttributes<HTMLInputElement>;

type LabeledRadioButtonGroupProps = {
  title: string;
  values: RadioButtonProps[];
  id?: string;
};
export const LabeledRadioButtonGroup: React.FC<LabeledRadioButtonGroupProps> = (props) => {
  const { title, values, id } = props;
  const items = values.map((item, i) => {
    return <RadioButton key={i} {...item} />;
  });
  return (
    <div>
      <FormSectionTitle text={title} htmlFor={id} id={`${id}-label`} />
      <div
        className={'flex gap-5 max-w-[500px]'}
        id={id}
        role="radiogroup"
        aria-labelledby={id ? `${id}-label` : undefined}
      >
        {items}
      </div>
    </div>
  );
};
